module.exports = __webpack_public_path__ + "img/spiral-details8.1f95284b.png";